import Modern61 from '../../Residential/Modern Mansion/Modern Mansion (1).webp'
import Modern62 from '../../Residential/Modern Mansion/Modern Mansion (1).webp'


const Modern6images =[
Modern61,Modern62
]

export default Modern6images;